<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-select v-model="query.levelName" class="m-2" :placeholder="query.levelName" size="small">
          <el-option v-for="item in levelTypes" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </el-col>
      <el-col :span="12" style="text-align: right">
        <el-pagination layout="prev, pager, next,sizes" :total="alarmTransactions.data.total" :page-sizes="pageSizes"
          :page-size.sync="query.pageSize" :current-page.sync="query.page" @current-change="load" @size-change="load">
        </el-pagination>
      </el-col>
    </el-row>
    <el-row class="tableFlex">
      <el-table v-loading="alarmTransactions.loading" :data="alarmTransactions.data.data" class="border">
        <el-table-column prop="createdAt" :label="$t('measurement.date')">
          <template slot-scope="scope">
            <span>{{ dateDate(scope.row.createdAt) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" :label="$t('dashboard.name')"></el-table-column>

        <el-table-column prop="point" :label="$t('dashboard.pointPath')" width="250px">
          <template slot-scope="scope">
            <span style="font-size: 11px">
              <em>{{ pathTran(scope.row.point) }}</em>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="telemetry" :label="$t('common.telemetry')" width="230px">
          <template slot-scope="scope">
            <span>{{ telemetryDisplayName(scope.row) }}</span>
          </template>
        </el-table-column>
        <el-table-column filter-placement="bottom-end" prop="level" :label="$t('dashboard.alarmLevel')">
          <template slot-scope="scope">
            <span>
              <em class="color-box" v-bind:style="{
                'background-color': getColor(scope.row.level.order),
              }"></em>
              {{ $t(`dashboard.lastalarms${scope.row.level.name}`) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="score" :label="$t('dashboard.score')">
          <template slot-scope="scope">
            <span>{{ scope.row.score.toFixed(4) }}
              {{
              scope.row.telemetry && (scope.row.telemetry.unit || "")
              }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="score" :label="$t('measurement.options')">
          <template slot-scope="scope">
            <router-link :to="{
              name: 'measurement',
              params: { id: scope.row.measurementId },
            }">{{ $t("measurement.details") }}
            </router-link>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <el-col :span="24" style="text-align: right">
        <el-pagination layout="prev, pager, next,sizes" :total="alarmTransactions.data.total" :page-sizes="pageSizes"
          :page-size.sync="query.pageSize" :current-page.sync="query.page" @current-change="load" @size-change="load">
        </el-pagination>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { treeHelper, colorLib } from "../util";
import dayjs from "dayjs-ext";
import preferences from "../util/preferences";

export default {
  name: "AlarmTransactions",
  props: ["pointId"],
  data() {
    return {
      query: {
        page: 1,
        pageSize: 10,
        levelName: "",
      },
      pageSizes: [10, 25, 50, 75],
      reload: false,
      levelTypes: [
        {
          label: this.$t("common.all"),
          value: "",
        },
        {
          label: this.$t("dashboard.lastalarmsattention"),
          value: "attention",
        },
        {
          label: this.$t("dashboard.lastalarmshazard"),
          value: "hazard",
        },
        {
          label: this.$t("dashboard.lastalarmscritical"),
          value: "critical",
        },
        {
          label: this.$t("dashboard.lastalarmshealthy"),
          value: "healthy",
        },
      ],
    };
  },
  computed: {
    ...mapState("account", ["customer"]),
    ...mapState("dashboard", ["alarmTransactions"]),
    ...mapState("admin", ["telemetry"]),
    ...mapState("tree",["flatTree"])
  },
  mounted() {
    // this.getTelemetry();
    this.load();
  },
  watch: {
    pointId() {
      this.load();
    },
    "query.levelName"() {
      this.load();
    },
  },
  methods: {
    filterLevel(value, row) {
      this.query.levelName = value.toLowerCase();
      return true;
    },

    // filterHandler(value, row, column) {
    //   const property = column["property"];
    //   return row[property] === value;
    // },
    ...mapActions("dashboard", ["getAlarmTransactions"]),
    ...mapActions("admin", ["getTelemetry"]),

    pathTran(id) {
      if (id) {
        return treeHelper.pointIdToPath(this.flatTree,id);
      } else {
        return "";
      }
    },
    telemetryDisplayName(v) {
      let telemetryName = v.telemetry;

      let telemetry = this.telemetry.data
        .filter((x) => x.hidden == false)
        .find((x) => v == x.name);
      if (telemetry && telemetry.displayName) {
        telemetryName = telemetry.displayName;
      }
        telemetryName = this.$t(`duck.${telemetryName}`) + ` (${this.$t("duck."+v.source.trim())})`;
      return telemetryName;
    },
    load() {
      this.getAlarmTransactions({
        pageSize: this.query.pageSize,
        pageNumber: this.query.page,
        filteredPoints: [this.pointId],
        levelName: this.query.levelName,
      });
    },
    riskColor(percentage) {
      return colorLib.getRiskColor(percentage);
    },
    getColor(order) {
      return colorLib.getAlarmColorByOrder(order);
    },
    dateDate(dateArray) {
      return dayjs(dateArray).format(preferences().localization.dateFormat);
    },

    path(id) {
      if (id) {
        return treeHelper.pointIdToPath(this.flatTree,id);
      } else {
        return "";
      }
    },
  },
};
</script>
<style >
.el-table__empty-block {
  display: flex;
  flex-direction: column;
  width: 100% !important;
  max-width: 100% !important;
}
</style>
<style scoped>
.tableFlex {
  display: flex;
  flex-direction: column;
  width: 100% !important;
  max-width: 100% !important;
}

.table.el-table__body {
  display: flex;
  flex-direction: column;
  max-width: 100% !important;
}

.row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.color-box {
  width: 10px;
  height: 10px;
  display: inline-block;
}
</style>